export default {
  metaTitle: 'Your review',
  common: {
    change: 'Change',
    privacyPolicy: 'Privacy Policy',
    accept: 'Accept',
    privacyPolicy2: 'Privacy Policy',
    edit: 'Edit',
    notThisFacility: 'Not this facility?',
    resign: 'Resign',
  },
  ratingForm: {
    button: 'Send rating',
    city: {
      title: 'Select location which you are rating',
      label: 'City',
      placeholder: 'Enter city',
    },
    store: {
      title: 'Location:',
      readonlyTitle: 'Rated location:',
      label: 'Select location',
    },
    maxValueLabel: 'Great',
    minValueLabel: 'Very bad',
    completed: {
      button: 'Rate in Google Maps',
    },
    optionalEmail: 'E-mail address (optional)',
    optionalPhoneNumber: 'Phone number (optional)',
  },
  reviewForm: {
    yourReview: 'Your review',
    button: 'Send review',
  },
  error: {
    title: 'An error occurred',
    content: 'Try again later',
  },
};
